/**
 * 创建人：但志强
 * 时间：2019-3-29
 * 描述：自定义选择框,作用于选择和提示
 * 使用说明: 参考 sw-massage-confirm 配置应用说明文档
 * 更新记录: 
 */
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { SwModalframeComponent } from '../sw-modal-frame/sw-modal-frame.component';
declare var $: any;

/**
 * 自定义选择框,作用于选择和提111示 sw-massage-confirm
 * 
 * ViewChild("tirm") tirm: SwMassageConfirmComponent; 
 * 
 *  this.tirm.openCLick("确认删除吗？", (data) => {})
 */
@Component({
  selector: 'sw-massage-confirm',
  templateUrl: './sw-massage-confirm.component.html',
  styleUrls: ['./sw-massage-confirm.component.css']
})
export class SwMassageConfirmComponent implements OnInit {

  /**
   * @ignore
   */
  constructor( 
  ) { }

  /**
   * 模态框的ID(用于多个模态框切换)
   * @ignore
   */
  ids: string;

  /**
   * 回调函数
   * @ignore
   */
  callback:any

  @Input() createType:number = 1  //创建组件的模式,默认是1,如果是2的话,就是动态创建的

  @Output() voted = new EventEmitter()

  @ViewChild("messageConfirmModal") messageConfirmModal: SwModalframeComponent;

  /**
   * x显示内容
   * @ignore
   */
  @Input() Title:string;

  /**
   * 是否显示取消按钮
   * @ignore
   */
  @Input() ifCancel: boolean = true; 
  /**
   * 标题
   * @ignore
   */
  @Input() headerLogo: string = "请选择"; 
  /**
   * @ignore
   */
  ngOnInit() {
    //创建唯一ID
    this.ids = "modal" + Math.random().toString().split(".")[1];
  }
  ngAfterViewInit(): void {
    if(this.Title){
      $("#"+this.ids).modal("toggle");
    }
  }


  /**
   * 回调函数
   * @param br 
   * @ignore
   */
  clickBut(br){
    $("#"+this.ids).modal("toggle");
    if(this.createType == 1){
      this.callback(br)
    }else {
      this.voted.emit(br)
    } 
  }


  /**
   * 打开选择框
   * @param title  显示的内容 
   * @param Back  执行的回调函数 function
   */
   openCLick(title,Back:any){
    this.Title = title
    //打开选择框
    $("#"+this.ids).modal("toggle");
    this.callback =Back;
   }

}
